// extracted by mini-css-extract-plugin
export default {"newsWidget":"NewsWidget_newsWidget__kzS4M"};